import { apiRequest } from './index';

export const fetchDepartmentRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/departments/' + id, {}, success, failure);
}

export const fetchDepartmentsRequest = ( success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/departments', {}, success, failure);
}

export const createDepartmentRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/departments',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editDepartmentRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/departments/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

const buildDepartmentOptions = department => ({
    value: department ? department._id : '',
    label: department ? department.departmentName : '',
    data: department
});

export const departmentSelectOptionRequest = (success = (result = []) => {}, failure = (error) => {}) =>{
    fetch(process.env.REACT_APP_API_ENDPOINT + '/departments')
        .then(response => response.json())
        .then(data => {
            const selectOptions = [];
            data.forEach((item) => {
                const option = buildDepartmentOptions(item);
                selectOptions.push(option);
            });
            success(selectOptions);
        })
        .catch(error =>{
            failure(error.status);
        });
}

export const deleteDepartmentRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/departments/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}
